import { ObjectModel } from 'objectmodel';

const _App = new ObjectModel({
  category: Number,
  default_locale: String,
  description: String,
  icons: Object,
  id: String,
  installed: Boolean,
  locales: Object,
  manifest_url: String,
  name: String,
  paid: Boolean,
  version: String
}).defaultTo({
  default_locale: 'en-US'
});

const BookmarkApp = _App
  .extend({
    type: ['bookmark'],
    url: String
  })
  .defaultTo({
    type: 'bookmark'
  });

const NormalApp = _App.extend({
  type: ['certified', 'hosted', 'privileged'],
  downloading: Boolean,
  installed: Boolean,
  paid: Boolean,
  progress: Number,
  updatable: Boolean
});

const Bookmark = new ObjectModel({
  url: String,
  icon: String,
  name: String
}).defaultTo({
  type: 'bookmark'
});

const MozApp = new ObjectModel({
  allowedAutoDownload: Boolean,
  downloadAvailable: Boolean,
  downloadSize: Number,
  downloading: Boolean,
  enabled: Boolean,
  installOrigin: String,
  installState: String,
  installTime: Number,
  lastUpdateCheck: Number,
  manifest: [Object],
  manifestURL: String,
  oldVersion: String,
  origin: String,
  progress: [Number],
  readyToApplyDownload: Boolean,
  receipts: [Array],
  removable: Boolean,
  role: [String],
  updateManifest: [Object],
  updateTime: [Number]
});

export { BookmarkApp, NormalApp, Bookmark, MozApp };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/App.js
 **/